export function convertArrayToString(value) {
    return Array.isArray(value) ? value.join(', ') : value;
}
